import Net from '../../util/net';

import {
  GetSMSCodeReq,
  GetSMSCodeRsp,
  LoginRsp,
  LoginReq,
  CheckMobileNumRsp,
  CheckMobileNumReq,
  ValidateInviteCodeReq,
  ValidateInviteCodeRsp,
  PasserenInviteCodeReq,
  PasserenInviteCodeRsp,
  GetInviteCodesReq,
  GetInviteCodesRsp,
  GenerateHTMLCountRsp,
  GenerateHTMLCountReq,
  GetSMSCodeCaptchaVerifyInfo,
} from '../../typings/proto';

export default {
  // 校验手机号检查是否虚拟运营商的
  checkMobileNum(phone: string): Promise<CheckMobileNumRsp> {
    return Net.request<CheckMobileNumRsp, CheckMobileNumReq>({
      path: 'knockknock.UserBaseSrv/CheckMobileNum',
      data: { num: phone },
    });
  },
  getSMSCode(phoneNumber: string, captchVerifyInfo: GetSMSCodeCaptchaVerifyInfo): Promise<GetSMSCodeRsp> {
    return Net.request<GetSMSCodeRsp, GetSMSCodeReq>({
      path: 'knockknock.ExternalLoginSrv/GetSMSCode',
      data: {
        phoneNumber,
        captchVerifyInfo,
      },
    });
  },
  // 登录
  login(phone: string, accountToken: string, loginType: number): Promise<LoginRsp> {
    return Net.request<LoginRsp, LoginReq>({
      path: 'knockknock.ExternalLoginSrv/Login',
      data: {
        accountAppid: phone,
        accountToken,
        loginType,
      },
    });
  },
  // 验证邀请码
  validateInviteCode(code: string): Promise<ValidateInviteCodeRsp> {
    return Net.request<ValidateInviteCodeRsp, ValidateInviteCodeReq>({
      path: 'knockknock.UserInviteSrv/ValidateInviteCode',
      data: {
        code,
      },
    });
  },
  // 消耗邀请码
  passerenInviteCode(code: string, uid: string): Promise<PasserenInviteCodeRsp> {
    return Net.request<PasserenInviteCodeRsp, PasserenInviteCodeReq>({
      path: 'knockknock.UserInviteSrv/PasserenInviteCode',
      data: {
        code,
        uid,
      },
    });
  },
  // 查询邀请码信息
  getInviteCodes(codeList: Array<string>): Promise<GetInviteCodesRsp> {
    return Net.request<GetInviteCodesRsp, GetInviteCodesReq>({
      path: 'knockknock.UserInviteSrv/GetInviteCodes',
      data: {
        codeList,
      },
    });
  },
  // 后台计算showAddDesktop 次数
  generateHTMLCount(isClick: boolean): Promise<GenerateHTMLCountRsp> {
    return Net.request<GenerateHTMLCountRsp, GenerateHTMLCountReq>({
      path: 'knockknock.FrontToolSrv/GenerateHTMLCount',
      data: {
        isClick,
      },
    });
  },
};

